import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../setup";

export const customerApi = createApi({
  reducerPath: "customerApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["CustomerProfile"],
  endpoints: (builder) => ({
    getCustomerMe: builder.query({
      query: () => ({
        url: `customer/me`,
        method: "GET",
      }),
      providesTags: [{ type: "CustomerProfile", id: "ME" }],
    }),
    updateCustomerMe: builder.mutation({
      query: (payload) => ({
        url: `customer/me`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: [{ type: "CustomerProfile", id: "ME" }],
    }),
    updateCustomerNotificationChannels: builder.mutation({
      query: ({ channels }) => ({
        url: `customer/me/notifications`,
        method: "PATCH",
        body: { channels },
      }),
      invalidatesTags: [{ type: "CustomerProfile", id: "ME" }],
    }),
    updateCustomerAllergies: builder.mutation({
      query: ({ allergies }) => ({
        url: `customer/me/allergies`,
        method: "PATCH",
        body: { allergies },
      }),
      invalidatesTags: [{ type: "CustomerProfile", id: "ME" }],
    }),
  }),
});

export const {
  useGetCustomerMeQuery,
  useUpdateCustomerMeMutation,
  useUpdateCustomerNotificationChannelsMutation,
  useUpdateCustomerAllergiesMutation,
} = customerApi;
